import { EventsRecords, StepEvent } from '@samelogic/steps';
import { mergeStepEventIntoEventRecords } from './mergeStepEventIntoEventRecords';

describe('mergeStepEventIntoEventRecords()', () => {
  type Case = {
    name: string;
    events: EventsRecords;
    stepEvent: StepEvent;
    expected: EventsRecords;
  };

  describe.each<Case>([
    {
      name: 'when event is empty',
      events: {},
      stepEvent: {
        stepName: 'test-step',
        event: 'test-event',
        data: {
          someData: 'test-data'
        }
      },
      expected: {
        'test-step': {
          'test-event': {
            data: {
              someData: 'test-data'
            }
          }
        }
      }
    },
    {
      name: 'when events is not empty',
      events: {
        'root-step': {
          'root-test-event': {
            data: {
              test: 'test'
            }
          }
        }
      },
      stepEvent: {
        stepName: 'test-step',
        event: 'test-event',
        data: {
          someData: 'test-data'
        }
      },
      expected: {
        'root-step': {
          'root-test-event': {
            data: {
              test: 'test'
            }
          }
        },
        'test-step': {
          'test-event': {
            data: {
              someData: 'test-data'
            }
          }
        }
      }
    }
  ])('$name', ({ events, stepEvent, expected }) => {
    it('should merge the step event data with existing data', () => {
      const got = mergeStepEventIntoEventRecords(events, stepEvent);
      expect(got).toEqual(expected);
    });
  });
});
